import * as THREE from 'three';

const textureLoader = new THREE.TextureLoader();
const textureCache = new Map();

function buildFallbackTexture() {
  const canvas = document.createElement('canvas');
  canvas.width = 128;
  canvas.height = 128;
  const ctx = canvas.getContext('2d');
  if (!ctx) return new THREE.Texture();
  ctx.clearRect(0, 0, 128, 128);
  ctx.fillStyle = '#1f1f1f';
  ctx.beginPath();
  ctx.arc(64, 64, 56, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = '#efefef';
  ctx.lineWidth = 8;
  ctx.stroke();
  ctx.fillStyle = '#efefef';
  ctx.font = 'bold 80px sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText('?', 64, 72);
  const tex = new THREE.CanvasTexture(canvas);
  tex.colorSpace = THREE.SRGBColorSpace;
  tex.needsUpdate = true;
  return tex;
}

const FALLBACK_TEXTURE = buildFallbackTexture();

function loadTexture(path, onReady) {
  if (!path) return FALLBACK_TEXTURE;
  if (textureCache.has(path)) return textureCache.get(path);
  textureCache.set(path, FALLBACK_TEXTURE);
  textureLoader.load(
    path,
    (tex) => {
      tex.colorSpace = THREE.SRGBColorSpace;
      textureCache.set(path, tex);
      onReady?.(tex);
    },
    undefined,
    () => {
      textureCache.set(path, FALLBACK_TEXTURE);
    },
  );
  return FALLBACK_TEXTURE;
}

/**
 * Create a reusable billboard sprite from a PNG asset path.
 * Falls back to an in-memory "?" sprite when the texture is missing.
 * @param {string} path
 * @param {{ size?: number, color?: number }} [opts]
 * @returns {THREE.Sprite}
 */
export function createBillboardSprite(path, opts = {}) {
  const material = new THREE.SpriteMaterial({
    map: loadTexture(path, (tex) => {
      material.map = tex;
      material.needsUpdate = true;
    }),
    transparent: true,
    depthWrite: false,
    color: opts.color ?? 0xffffff,
  });
  const sprite = new THREE.Sprite(material);
  const size = Number.isFinite(opts.size) ? Math.max(0.1, opts.size) : 1.25;
  sprite.scale.set(size, size, size);
  return sprite;
}
